// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6452":"d59c8d9d","6850":"bdddd257"}[chunkId] + ".chunk.css";
};